import React, { useEffect, useRef, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { addSelectedActivity, setIsStepFourLoading, setOpportunity, setPaymentCountDown, setSelectedActivity, updateActivityItem, addOpportunityProduct, resetSelections, removeActivity, setState, setAllowUpSale, setColumnMessage, setActivityTiming, setCurrentStep, setCreateMode } from "../../store/MahutiReducer";
import { addActivity, editActivity, getAmount, getUpsaleSF, setOportunity } from "../../utils/sfUtils";
import UpsaleActivity from "../upsale-activity/UpsaleActivity";
import CustomerDetails from "../customer-details/CustomerDetail";
import MahutiModal from "../mahuti-modal/MahutiModal";
import './LandingPageStepFour.css'
import { onBrowserBackButtonHandle } from "../../utils/stepperUtils";
import { useLocation, useNavigate } from "react-router-dom";
import { ELEMENT_LINK, GETUPSALE_CALL_LIMIT, PREFIX_PATH, scrollToSection, YOUR_REQUEST_IS_SAVED } from "../../utils/GlobalParams";
import { ClearLocalStorage, getLocalStoragKey } from "../../store/mahutiLocalStorage";
import { calculateCountDownSeconds, checkTimestemp, clearAll } from "../../utils/orderUtils";
import { cartActionForActivity } from "../../utils/cartUtils";
import { isMobile } from "react-device-detect";


function LandingPageStepFour(props) {

    const [modalOpen, setModalOpen] = useState(false);
    const [useDisclaimer, setUseDisclaimer] = useState(false);
    const store = useSelector(store => store.reducer);
    const dispatch = useDispatch();
    const location = useLocation();
    const navigate = useNavigate();
    const [upsaleActivities, setUpsaleActivities] = useState(undefined)
    const [isUpsaleLoading, setIsUpSaleLoading] = useState(true);
    const kidsTickets = store.visitors?.underAge || 0;
    const adults = store.visitors?.underAge || 0;
    const lpPrefix = store.lpName ? '/' + store.lpName : '';
    let disclaimerOnce = []

    const getUpsale = () => {
        if(store.selectedActivity){
            finalMount.upsaleCallCount < GETUPSALE_CALL_LIMIT && getUpsaleSF(store).then(res => {
                if (!res.data || !res.data.records || !res.data.records[0] || res.data === 'no Upsale') {

                }
                else {
                    setUpsaleActivities(res.data && res.data.records && res.data.records[0]);
                    finalMount.upsaleCallCount = finalMount.upsaleCallCount + 1
                    dispatch(setAllowUpSale(false))
                }
                setIsUpSaleLoading(false);

            }).catch(err => {
                setIsUpSaleLoading(false);
                finalMount.upsaleCallCount = finalMount.upsaleCallCount + 1;
            })
        }
    }

    const checkOpportunity = () => {
        store.opportunity?.id ? addToCart(store.selectedActivity) : callSF(store.selectedActivities);
    }

    const init = () => {
        const referralUrl = location.state?.referralUrl;
        referralUrl && console.log('Referral URL:', referralUrl)
        //if user got into checkout page without cart
        if (window.performance && performance.navigation.type == 1 && store.selectedActivities.length === 0 && store.refresh) {
            dispatch(setPaymentCountDown({status: 'DONE', timer: undefined}));
            dispatch(removeActivity('*'))
            ClearLocalStorage()
            dispatch(setOpportunity())
            dispatch(resetSelections())
            clearAll(dispatch) //test cache bug
            navigate(PREFIX_PATH + lpPrefix + '/' );               
        }else{
            scrollToSection(ELEMENT_LINK["#sellingflow"]);
            setModalOpen(true);
            store.allowUpSale && getUpsale()
            handleSelectedActivityToCart()  
        }
    }

    const startTimer = () => {
        let secLeft = checkTimestemp(getLocalStoragKey('countDownTimestemp'), false)
        if(!secLeft){
            let minutes = calculateCountDownSeconds(true, false, store)
            dispatch(setPaymentCountDown({ status: 'Pending', timer: minutes }));
        }
    }

    const navigationEntries = window.performance.getEntriesByType('navigation');
    let finalMount = useRef(true);
    useEffect(() => {
        if (location.state && location.state.from) {
            console.log(location.state.from.pathname);
        }

        if (finalMount.current) {
            scrollToSection(ELEMENT_LINK["#sellingflow"]);
            finalMount.current = false;
            finalMount.upsaleCallCount = 0; 
            init()
        }
        return () => {
            onBrowserBackButtonHandle(store, dispatch, navigate, location, () => { });
        }
    }, [])

    useEffect(() => {
        setUseDisclaimer(false)
    }, [store.selectedActivities])

    const handleSelectedActivityToCart = async () => {
        if (store.selectedActivity) {
            /*
              Re-entering checkout (e.g. browser back) must not re-add the
              activity: once the opportunity exists, both the Redux cart and
              the SF opportunity already hold this item - re-adding duplicated
              the cart row AND created a second OpportunityLineItem.
            */
            const cartAction = cartActionForActivity(store.selectedActivity, store.selectedActivities, store.opportunity?.id)
                if(store.selectedActivity.price && store.selectedActivity.visitors && store.selectedActivity.timing && !store.refresh && store.createMode){
                    if (cartAction === 'add') {
                        dispatch(addSelectedActivity({ ...store.selectedActivity, tickets: kidsTickets + adults, activityDate: store.activityDate }));
                        checkOpportunity()
                    } else if (cartAction === 'create-opportunity') {
                        callSF(store.selectedActivities)
                    }
                }else{
                    if(store.selectedActivities?.length === 0){
                        console.log('checkout send client home')
                        navigate(PREFIX_PATH + lpPrefix + '/' );
                    }
                }
            // }else {
            //     if(store.opportunity){
            //         if (store.opportunity.id && store.opportunityProduct) {
            //             try{
            //                 dispatch(setIsStepFourLoading(true));
            //                 let index = store.opportunityProduct.findIndex(item => item.campaignId === store.lastEditedActivityCampaignId)
            //                 if(index !== -1){
            //                     dispatch(updateActivityItem({ ...store.selectedActivity, visitors: { adults: store.visitors?.adults, underAge: store.visitors?.underAge }, tickets: kidsTickets + adults, activityDate: store.activityDate }));   
            //                     let res = await editActivity([store.selectedActivity], store.opportunityProduct[index].opportunityProduct, store.opportunity.id)
            //                     dispatch(setOpportunity({ amount: res.data.Newamount, discount: res.data.Discount }));
            //                 }
            //                 dispatch(setIsStepFourLoading(false));
            //             }catch(err){
            //                 console.log(err)
            //             } 
            //         }
            //     }else{
            //         navigate(PREFIX_PATH + lpPrefix + '/' );
            //         clearAll(dispatch)
            //     }
            // }
        }

        if (!store || !store.selectedActivity || (!store.selectedActivity.campaignId || !store.selectedActivity.Id)) {
            // onrefresh
            const selectedActivityLocal = localStorage.getItem('step') ? JSON.parse(localStorage.getItem('step')) : undefined
            if (selectedActivityLocal && (!store.selectedActivity || !store.selectedActivity.campaignId)) {
                dispatch(setSelectedActivity(selectedActivityLocal.selectedActivity));
            }
            console.log('refresh')
        }

        dispatch(setCreateMode(true))

    }

    const callSF = async (selectedActivities) => {
        dispatch(setIsStepFourLoading(true));
        setOportunity(selectedActivities.length > 0 ? selectedActivities : [{
            ...store.selectedActivity,
            visitors: store.visitors,
            Campaign_Id: store.selectedActivity.campaignId,
            product_id: store.selectedActivity.Id
        }], store.customerDetails)
        .then(res => {
            dispatch(setOpportunity({ id: res.data.opportunityId, amount: res.data.totalAmount , orderId: res.data.orderId}));   
            dispatch(addOpportunityProduct({campaignId: store.selectedActivity.campaignId, opportunityProduct: res.data.opportunityProduct, adults: store.selectedActivity.visitors.adults, underAge: store.selectedActivity.visitors.underAge}))
            dispatch(setColumnMessage({...store.columnMessage, info: YOUR_REQUEST_IS_SAVED + ' ' + store.lpParams.cartTimer + ' דקות'}))
            startTimer()
        })
        .catch(err => {
            console.error(err)
            dispatch(setColumnMessage({...store.columnMessage, alert: 'היתה תקלה בהוספה לסל, יש לנסות שנית'}))
            dispatch(removeActivity({campaignId: store.selectedActivity.campaignId, adults: store.selectedActivity.visitors.adults, underAge: store.selectedActivity.visitors.underAge}))
            setTimeout(() => {
                dispatch(setColumnMessage())
                if (store.steps[store.currentStep - 1].name === 'timeSelection') {
                    dispatch(setActivityTiming(undefined));
                }
                dispatch(setCurrentStep(store.currentStep - 1));
            }, 3000)
        })
        .finally(() => {
            dispatch(setIsStepFourLoading(false));
        })
    }

    const addToCart = async (newActivity, isUpsale = false) => {
        dispatch(setIsStepFourLoading(true));
        setModalOpen(false); 
        try{
            let res = await addActivity([newActivity], store.opportunity?.id);
            dispatch(setOpportunity({ amount: res.data.Newamount, discount: res.data.Discount}));
            dispatch(addOpportunityProduct({campaignId: newActivity.campaignId, opportunityProduct: res.data.opportunityProduct, adults: newActivity.visitors.adults, underAge: newActivity.visitors.underAge}))
            isUpsale && dispatch(addSelectedActivity(newActivity))
            startTimer()
            dispatch(setIsStepFourLoading(false));
        } catch (err) {
            dispatch(setColumnMessage({...store.columnMessage, alert: 'היתה תקלה בהוספה לסל, יש לנסות שנית'}))
            dispatch(removeActivity({campaignId: store.selectedActivity.campaignId, adults: store.selectedActivity.visitors.adults, underAge: store.selectedActivity.visitors.underAge}))
            setTimeout(() => {
                dispatch(setColumnMessage())
                if (store.steps[store.currentStep - 1].name === 'timeSelection') {
                    dispatch(setActivityTiming(undefined));
                }
                dispatch(setCurrentStep(store.currentStep - 1));
            }, 3000)
            dispatch(setIsStepFourLoading(false))
        }   
    }
    return <div tabIndex='-1' id="main-content" className="landingPageStepFour p-3 pb-0 ps-lg-5 pe-lg-4 pt-lg-4 pb-lg-0">
        <div className="">
            <div className={`title d-flex ${isMobile ? 'justify-content-center' : 'justify-content-start'}`}>
                <span className="text-lg-start text-center mb-2 mb-lg-0">
                    <h2 className={`alef fw-bold step_four_title ${useDisclaimer ? '' : 'no_disclaimer'}`}>רגע לפני הרכישה</h2>
                    {
                        store.selectedActivities?.map((item, inx) => {
                            if(item?.disclaimer && item?.disclaimer.length > 0){
                                return item.disclaimer.map((disclaimer, index) => {
                                    if(!disclaimerOnce.includes(disclaimer.Id)){
                                        disclaimerOnce.push(disclaimer.Id)
                                        !useDisclaimer && setUseDisclaimer(true)
                                        return disclaimer.Name && <span className="disclaimer alef" key={disclaimer.Id}>{(index > 0 && inx >= 0) ? isMobile ? <br/> : '| ' : ''} *{disclaimer.Name} </span>
                                    }
                                })
                            }
                        })
                    }
                </span>
            </div>
            <div className="">
                {modalOpen && upsaleActivities && <MahutiModal closeModalWhenClickingBg={true} setModalOpen={setModalOpen}>
                    {isUpsaleLoading ? <div className="col"><div className="loader" /></div> :
                        <UpsaleActivity 
                            index='1'
                            visitors={store.visitors}
                            upsaleActivities={upsaleActivities}
                            onClose={() => { setModalOpen(false); }}
                            addToCart={addToCart}
                            className='upsale_popup'
                        />
                    }
                </MahutiModal>}
            </div>
        </div>

        
        <CustomerDetails />
        

    </div>
}

export default LandingPageStepFour;